
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuTerraceTerraceImage } from "@src/constants/images";
import { meta as crisscrossPageMeta } from "./crisscross.mdx";
export const meta = {
  path: "/media/harajuku/terrace",
  title: "【名店揃い！？】テラス席でランチが食べられる原宿のお店４選",
  description: "原宿でテラス席のランチが食べられる名店を５選ご紹介します。食べログで好評価や百名店に選ばれているお店を中心に厳選してご紹介します。また、各店舗のテラス席や、人気のメニューについて写真付きでご紹介しますので、お好みの店を見つけて、素敵なランチタイムをお過ごしください。",
  topImg: harajukuTerraceTerraceImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "おしゃれな内装", "人気店", "まとめ記事", "デート", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でテラス席のランチが食べられる名店を５選ご紹介します。`}</p>
    <p>{`食べログで好評価や百名店に選ばれているお店を中心に厳選してご紹介します。`}</p>
    <p>{`テラス席が人気でデートや女子会で使われているお店、世界一の朝食として名高いお店、外国人も訪れる朝食でも行列ができるお店、特徴的な名前で原宿エリアでは知らない人はいないお店など、それぞれの特徴をご紹介します。`}</p>
    <p>{`各店舗のテラス席や、人気のメニューについて写真付きでご紹介しますので、お好みの店を見つけて、素敵なランチタイムをお過ごしください！`}</p>
    <h2>{`【ピザ】ピッツェリア　カンテラ`}</h2>
    <InstaImage postId="CAjayRwgZvd" mdxType="InstaImage" />
    <p>{`原宿で有名なピザのお店として知られるピッツェリア カンテラは、開放的なテラス席を完備しているお店です。
3 年連続百名店に選出されるピザ業界でも屈指の名店で、食べログの評価は 3.7 を超える好評価。`}</p>
    <p>{`カンテラのテラス席についてご紹介します。`}</p>
    <h3>{`スタイリッシュな店内とテラス席`}</h3>
    <InstaImage postId="B-OtdENg96g" mdxType="InstaImage" />
    <InstaImage postId="B_Ty33uAgGC" mdxType="InstaImage" />
    <p>{`原宿というよりは表参道にあるお店のようなスタイリッシュな内装で、デートや女子会でたくさん使われている雰囲気のあるお店です。テラス席は開放的で原宿エリアを一望することができ、晴れた日には最高のランチタイムを過ごすことができます。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="B6ws-aUAh6Z" mdxType="InstaImage" />
    <InstaImage postId="B_7US6xAouz" mdxType="InstaImage" />
    <p>{`二人以上で行くなら、ピザかパスタセットを別々で頼むのがおすすめです！産地の新鮮な食材やこだわりのある全粒粉の小麦粉を使ったピザなどのメニューが盛り沢山！シェアして食べるのがいいと思います。`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】bills 東急プラザ表参道原宿`}</h2>
    <InstaImage postId="B-CeBPwDONN" mdxType="InstaImage" />
    <p>{`オーストラリアシドニー発祥のお店で、ハリウッドセレブをはじめとして多くの有名人が訪れることで有名な bills。その朝食は世界一とまで言われるほど、ずっと人気であり続けています。原宿と表参道の間に位置し、原宿エリアで最大規模のお店の広さを誇るお店には、テラス席が用意されています。`}</p>
    <h3>{`原宿最大級の席数とテラス席`}</h3>
    <InstaImage postId="B-dqZL3Bq4y" mdxType="InstaImage" />
    <p>{`Bills 原宿の店舗は、広々とした店内の設計になっていて、なんとその席数は 122 席。`}</p>
    <InstaImage postId="B99NmMcAHbJ" mdxType="InstaImage" />
    <p>{`テラス席は 14 席なので数に限りがあるのですが、行列の時間帯である 12 時前〜夕方を避けると座れる可能性があります。
早めのランチができる時は、bills を選択肢に入れてみてください！`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <p>{`サーモンとズッキーニのサラダ`}</p>
    <InstaImage postId="CBM-FFCFBMx" mdxType="InstaImage" />
    <p>{`人気のパンケーキ`}</p>
    <InstaImage postId="CB-5nJIHaZu" mdxType="InstaImage" />
    <ShopInfoBox shopId="brmklui23akg009e18vg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】クリスクロス`}</h2>
    <p>{`原宿から表参道方面に歩いて行くと、開放的なレンガ調のテラス席を備えたお店がクリスクロス です。
朝食で食べられるパンケーキが有名なお店で、朝でも行列ができることもあるそうです。`}</p>
    <p>{`食べログの評価は、3.6 を超える好評価のお店で、人気の勢いは止まりません。`}</p>
    <h3>{`開放的なテラス席`}</h3>
    <InstaImage postId="B9CF69OhPCQ" mdxType="InstaImage" />
    <p>{`開放的なテラス席はソファーなども完備しており、開放的な空間でランチをすることができます！外国の方もたくさん訪れるそうで、日常とは少し違った体験がができるのではないでしょうか。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <h4>{`ウィークリーラランチプレート (税込：1,600 円)`}</h4>
    <InstaImage postId="B5HRSRlpo2k" mdxType="InstaImage" />
    <p>{`週替わりでメニューが変わるランチプレートも豪華な食べ応えのあるメニューがたくさんあります！
こちらはチキンのソテーになりますが、お越しの際にはぜひ店員さんにランチメニューを確認してみてください。`}</p>
    <h4>{`バターミルクパンケーキ(税込：1,700 円)`}</h4>
    <InstaImage postId="B_uJ2J8D6yd" mdxType="InstaImage" />
    <p>{`冒頭でお伝えした人気のメニューがこちらです。クこのソーセージは自家製で、ジューシーなソーセージともちっとしたパンケーキの組み合わせがオリジナルの味を生み出します。大人気のパンケーキをランチでも堪能してみてください！`}</p>
    <LinkWithThumbnail meta={crisscrossPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="bs08n7a23akg0088jkp0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】パンとエスプレッソと`}</h2>
    <InstaImage postId="By4KgQaF5G3" mdxType="InstaImage" />
    <p>{`4 年連続百名店に選ばれる原宿・表参道エリアで、人気のお店が「パンとエスプレッソと」。
特徴的な名前なので覚えやすいこちらのお店は、食べログの評価は 3.8 を超え、出来立てのパンを求めて、ランチだけでなく朝の時間帯にも行列ができるほどです。`}</p>
    <p>{`そんな、パンとエスプレッソのテラス席について、ご紹介します。`}</p>
    <h3>{`都会に合うスタイリッシュなテラス席`}</h3>
    <InstaImage postId="B8-ydEBFfjf" mdxType="InstaImage" />
    <p>{`白とグレーで統一されたデザインで、店前のスペースが広く、テラス席となっています。
原宿に佇むアパレルショップのような雰囲気で、雰囲気もランチで楽しめるお店です。`}</p>
    <h3>{`ランチメニュー`}</h3>
    <InstaImage postId="BpYW7diAv7R" mdxType="InstaImage" />
    <p>{`パンのランチは平日と週末で 2 つのセットがありますが、内容はほとんど一緒になります。パニーニやキッシュなど、普段なかなか食べる機会がないメニューを堪能することができます。`}</p>
    <p>{`名店のパンのランチを、開放的で洗練されたお店で楽しんでみてください！`}</p>
    <ShopInfoBox shopId="brisonq23akg00cd2nfg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿でテラス席でランチが食べられるお店をご紹介してきましたが、いかがでしたでしょうか。
それぞれのお店に素敵なテラス席を完備しており、素敵なランチタイムが過ごせるような雰囲気抜群のお店が多かったのではないかと思いま　
その日の気分や状況に合わせてお店を選んでみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;